module.exports = {
        srcSet: __webpack_public_path__ + "static/media/discountCoupon-498.7577fe10.webp"+" 498w",
        images: [{path: __webpack_public_path__ + "static/media/discountCoupon-498.7577fe10.webp",width: 498,height: 498}],
        src: __webpack_public_path__ + "static/media/discountCoupon-498.7577fe10.webp",
        toString: function(){return __webpack_public_path__ + "static/media/discountCoupon-498.7577fe10.webp"},
        
        width: 498,
        height: 498
      }